// extracted by mini-css-extract-plugin
module.exports = {"PasswordResetEmailForm__submit":"zg_a bhu_pp bhu_sk"};